import axios from "../axiosConfig";

class Routes {
  // Every role with its grants and how many users hold it.
  getAllRoles = () => {
    let data = axios.get("/api/roles");
    return data;
  };

  // The permission catalog, grouped by module for the checkbox grid.
  getPermissionCatalog = () => {
    let data = axios.get("/api/roles/permissions");
    return data;
  };

  // Names only, for the role dropdown on the user form. Needs users.create or
  // users.edit rather than roles.manage, so it stays usable by whoever may
  // add a user without being a full administrator.
  getAssignableRoles = () => {
    let data = axios.get("/api/roles/assignable");
    return data;
  };

  createRole = (val) => {
    let data = axios.post("/api/roles", val);
    return data;
  };

  updateRole = (id, val) => {
    let data = axios.put(`/api/roles/${id}`, val);
    return data;
  };

  // Replaces the role's grants with exactly the keys supplied.
  setRolePermissions = (id, permissions) => {
    let data = axios.put(`/api/roles/${id}/permissions`, { permissions });
    return data;
  };

  deleteRole = (id) => {
    let data = axios.delete(`/api/roles/${id}`);
    return data;
  };
}

export default new Routes();
